/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUserResponse
 */
export interface CreateUserResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateUserResponse
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserResponse
     */
    authProviderId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserResponse
     */
    invitationUrl?: string | null;
}

/**
 * Check if a given object implements the CreateUserResponse interface.
 */
export function instanceOfCreateUserResponse(value: object): value is CreateUserResponse {
    return true;
}

export function CreateUserResponseFromJSON(json: any): CreateUserResponse {
    return CreateUserResponseFromJSONTyped(json, false);
}

export function CreateUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'authProviderId': json['authProviderId'] == null ? undefined : json['authProviderId'],
        'invitationUrl': json['invitationUrl'] == null ? undefined : json['invitationUrl'],
    };
}

export function CreateUserResponseToJSON(value?: CreateUserResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'message': value['message'],
        'authProviderId': value['authProviderId'],
        'invitationUrl': value['invitationUrl'],
    };
}

